// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hzEc","controls":"styles_controls__20_QB","charLimit":"styles_charLimit__H8DO_","input":"styles_input__3b02E","send":"styles_send__3fWjd"};